// いま表示している言語。選んだ言語はこの端末に覚えておく

import { getContent, type Content } from "../shared/content";
import { DEFAULT_LOCALE, LOCALE_TAGS, isLocale, matchLocale, type Locale } from "../shared/i18n";
import { UI_TEXT, type UI } from "./ui";

const LANG_KEY = "bm:lang";

/**
 * 1. この端末で前に選んだ言語
 * 2. ブラウザの言語 (対応しているもの)
 * 3. リンクの ?lang= (シェアした人の言語)
 * 4. どれもなければ英語 (日本語のブラウザなら 2 で日本語になる)
 */
function detect(): Locale {
  try {
    const saved = localStorage.getItem(LANG_KEY);
    if (isLocale(saved)) return saved;
  } catch {
    // 保存できない環境では、毎回ブラウザの言語から選ぶ
  }
  for (const tag of navigator.languages ?? [navigator.language]) {
    const l = matchLocale(tag);
    if (l) return l;
  }
  const fromUrl = new URLSearchParams(location.search).get("lang");
  if (isLocale(fromUrl)) return fromUrl;
  return navigator.languages?.length ? "en" : DEFAULT_LOCALE;
}

let locale: Locale = detect();

export const getLocale = () => locale;
export const content = (): Content => getContent(locale);
export const t = (): UI => UI_TEXT[locale];

/** 日付 (例: 2026年10月23日 / October 23, 2026) */
export const formatDate = (iso: string, withYear = true) =>
  new Date(iso).toLocaleDateString(LOCALE_TAGS[locale], {
    timeZone: "Asia/Tokyo",
    ...(withYear ? { year: "numeric" } : {}),
    month: "long",
    day: "numeric",
  });

/** ページ全体 (html の lang、タイトル、説明) をいまの言語にする */
export function applyLocale(): void {
  const c = content();
  document.documentElement.lang = locale;
  // シェアされた役のページ (/r/{役}) のタイトルは Worker が役ごとに入れているので、トップページのときだけ変える
  if (!location.pathname.startsWith("/r/")) document.title = c.site.title;
  document.querySelector('meta[name="description"]')?.setAttribute("content", c.site.description);
}

export function setLocale(next: Locale): void {
  locale = next;
  try {
    localStorage.setItem(LANG_KEY, next);
  } catch {
    // 覚えておけなくても、この表示のあいだは切り替わる
  }
  applyLocale();
}
